export const GENETIC_INFO_TYPE_MAP: Record<string, string> = {
  'health-risk': 'Health Risk',
  'carrier-status': 'Carrier Status',
};

export const GENETIC_INFO_TYPES = Object.entries(GENETIC_INFO_TYPE_MAP).map(
  ([key, value]) => ({ k: key, v: value })
);
